/* 템플릿 미리보기용 예시 사진 — Gemini 이미지 모델로 새로 만든 사진(2026-10-19). 실제 현장·외부 사진은 쓰지 않는다.
   미리보기에만 쓰고, 템플릿 페이지를 문서에 넣을 때는 빈 사진 칸으로 바꾼다(clearSamplePhotos). */
import BATHROOM_1 from '../assets/samples/BATHROOM_1.webp';
import BATHROOM_2 from '../assets/samples/BATHROOM_2.webp';
import BATHROOM_3 from '../assets/samples/BATHROOM_3.webp';
import BATHROOM_4 from '../assets/samples/BATHROOM_4.webp';
import BATHROOM_5 from '../assets/samples/BATHROOM_5.webp';
import BEDROOM_1 from '../assets/samples/BEDROOM_1.webp';
import BEDROOM_2 from '../assets/samples/BEDROOM_2.webp';
import BEDROOM_3 from '../assets/samples/BEDROOM_3.webp';
import DINING_ROOM_1 from '../assets/samples/DINING_ROOM_1.webp';
import DINING_ROOM_2 from '../assets/samples/DINING_ROOM_2.webp';
import ENTRANCE_1 from '../assets/samples/ENTRANCE_1.webp';
import ENTRANCE_2 from '../assets/samples/ENTRANCE_2.webp';
import KITCHEN_1 from '../assets/samples/KITCHEN_1.webp';
import KITCHEN_2 from '../assets/samples/KITCHEN_2.webp';
import KITCHEN_3 from '../assets/samples/KITCHEN_3.webp';
import KITCHEN_4 from '../assets/samples/KITCHEN_4.webp';
import KITCHEN_5 from '../assets/samples/KITCHEN_5.webp';
import KITCHEN_6 from '../assets/samples/KITCHEN_6.webp';
import LIVING_ROOM_1 from '../assets/samples/LIVING_ROOM_1.webp';
import LIVING_ROOM_2 from '../assets/samples/LIVING_ROOM_2.webp';
import LIVING_ROOM_3 from '../assets/samples/LIVING_ROOM_3.webp';
import LIVING_ROOM_4 from '../assets/samples/LIVING_ROOM_4.webp';
import type { Page } from './types';

export const SAMPLE_PHOTOS: Record<string, string[]> = {
  ENTRANCE: [ENTRANCE_1, ENTRANCE_2],
  LIVING_ROOM: [LIVING_ROOM_1, LIVING_ROOM_2, LIVING_ROOM_3, LIVING_ROOM_4],
  KITCHEN: [KITCHEN_1, KITCHEN_2, KITCHEN_3, KITCHEN_4, KITCHEN_5, KITCHEN_6],
  DINING_ROOM: [DINING_ROOM_1, DINING_ROOM_2],
  BEDROOM: [BEDROOM_1, BEDROOM_2, BEDROOM_3],
  BATHROOM: [BATHROOM_1, BATHROOM_2, BATHROOM_3, BATHROOM_4, BATHROOM_5],
};
const SAMPLE_SET = new Set(Object.values(SAMPLE_PHOTOS).flat());
export const isSamplePhoto = (src?: string) => !!src && SAMPLE_SET.has(src);

/** 미리보기 페이지를 문서에 넣을 때 — 예시 사진은 빈 칸(회색)으로. 사진 탭에서 사진을 골라 채운다 */
export function clearSamplePhotos(page: Page): Page {
  page.elements.forEach((e) => { if (e.type === 'image' && isSamplePhoto(e.src)) delete e.src; });
  return page;
}
